import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  DELETE_GROUP_BUTTON: `${cleanedFilename(__filename)}-delete-group-button`,
};
